<template>
  <li class="coupon-item" :class="statusClass[status]">
    <div class="coupon-item-info" :class="size">
      
      <div class="coupon-money-box">
        <div class="coupon-status" v-if="status == 1 && item.nearExpiration">
          <img src="../../../assets/image/coupon-icon-4.png" class="status-time" alt="">
        </div>
        <div class="coupon-status" v-if="status == 2">
          <img src="../../../assets/image/coupon-icon-3.png" class="" alt="">
        </div>
        <div class="coupon-status" v-if="status == 3">
          <img src="../../../assets/image/coupon-icon-6.png" class="" alt="">
        </div>
        <div class="coupon-money" v-if="item.rule && item.rule.discount">
          <div class="money"><span class="unit">¥</span>{{item.rule.discount.discount}}</div>
          <div class="coupon-text">满{{item.rule.discount.condition}}元可用</div>
        </div>
        <div class="coupon-info">
          <div class="coupon-title text-hide">{{item.couponTitle}}</div>
          <div class="coupon-time">{{item.releaseTime | timeStr('date')}}-{{item.endTime |timeStr('date')}} <span class="go-tag" v-if="status == 1" @click="goHome">去使用</span></div>
          <div class="coupon-details" @click="getMyCouponInstructions">详细信息 
            <img src="../../../assets/image/coupon-icon.png" v-if="detailsShow" alt="">
            <img src="../../../assets/image/coupon-icon-2.png" v-else alt="">
          </div>
        </div>
      </div>
      <div class="coupon-details-content" v-if="detailsShow" @click="goOrder">
        <template v-if="status == 2">
          <p>该优惠券已用在:</p>
          <p>订单号：{{item.orderNo}}</p>
          <p>{{item.staName}}</p> 
          <p>{{item.useTime}}</p>
        </template>
        <p v-else>{{text}}</p>
      </div>
    </div>
  </li>
</template>
<script>
import { getMyCouponInstructions } from "@/common/api";
export default {
  name: 'pi-coupon-item',
  components: {
    
  },
  data(){
    return{
      statusClass: {
        '1': 'primary',
        '2': 'status-yes',
        '3': 'status-be-overdue',
      },
      detailsShow: false,
      text: ''
    }
  },
  methods: {
    getMyCouponInstructions() {
      this.detailsShow = !this.detailsShow;

      if(this.detailsShow && this.text == ''){
        getMyCouponInstructions({
        couponTemplatePkId: this.item.couponTemplatePkId
      })
        .then(response => {
          if (response.status == this.$config.ajaxStatus) {
            this.text = response.data[0] || '';
          }
        })
      }
      
    },
    goHome(){
      this.$router.push('/home2');
      this.$emit('go');
    },
    goOrder(){
      if(this.item.orderNo){
        this.$router.push({
          name: "my/order/details",
          query: { orderNo: this.item.orderNo }
        });
      }
    }
  },
  mounted() {
  },
  props: {
    status: {
      type:  Number,
      default: 0
    },
    size: {
      type:  String,
      default: ''
    },
    item: {
      type: Object,
      default:()=>{
        return {}
      }
    }
  }
}
</script>
<style lang="less">

  .coupon-item{
    position: relative;
    margin-top: 0.2rem;
    .coupon-status{
      position: absolute;
      right: 0;
      top: 0;
    }
    .status-time{
      width: 1rem;
      height: 0.58rem;
    }
    .coupon-money-box{
      display: flex;
      position: relative;
      .coupon-money{
        width: 2rem;
        height: 2rem;
        background-image: url('../../../assets/image/coupon-icon-5.png');
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 0.42rem 0;
        text-align: center;
        color: #fff;
        .money{
          font-size: 0.6rem;
          line-height: 0.84rem;
          .unit{
            font-size: 0.34rem;
            line-height: 0.48rem;
          }
        }
      }
      .coupon-text{
        font-size: 0.24rem;
        line-height: 0.33rem;
      }
    }
    .coupon-info{
      flex: 1;
      padding: 0.25rem 0.2rem 0 0.2rem;
      background-color: #Fff;   
      border-radius: 0px 0.1rem 0.1rem 0px;
      .coupon-title{
        font-size: 0.34rem;
        line-height: 0.48rem;
        color: #333;
      }
      .coupon-time{
        margin-top: 0.1rem;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #666;
        padding-right: 0.6rem;
        position: relative;
        .go-tag{
          display: inline-block;
          border: 0.01rem solid #14CC80;
          color: #14CC80;
          border-radius: 0.19rem;
          line-height: 0.38rem;
          font-size: 0.24rem;
          padding: 0 0.1rem;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .coupon-details{
        color: #666;
        font-size: 0.28rem;
        line-height: 0.4rem;
        margin-top: 0.1rem;
        border-top: 0.02rem dashed #EEEEEE;
        padding-top: 0.13rem;
        img{
          width: 0.3rem;
          float: right;
          margin-top: 0.04rem;
        }
      }
    }
  }
  .coupon-item:first-child{
    margin-top: 0;
  }
  .coupon-details-content{
    padding: 0.2rem;
    background-color: #fff;
    font-size: 0.24rem;
    line-height: 0.33rem;
    color: #666;
  }
  .coupon-item.status-yes,.coupon-item.status-be-overdue{
    .coupon-status img{
      width: 0.98rem;
      height: 1.2rem;
    }
    .coupon-money{
      opacity: 0.5;
    }
  }
  .coupon-item-info.small{
     .coupon-money-box .coupon-money .money{
      font-size: 0.45rem;
      line-height: 0.64rem;
      .unit {
        font-size: 0.25rem;
        line-height: 0.36rem;
      }
    }
     .coupon-money-box .coupon-money{
      width: 1.52rem;
      height: 1.52rem;
    }
     .coupon-money-box .coupon-text{
      font-size: 0.18rem;
      line-height: 0.25rem;
    }
     .coupon-info .coupon-title {
        font-size: 0.25rem;
        line-height: 0.36rem;
        color: #333;
    }
     .coupon-info .coupon-time {
        margin-top: 0.08rem;
        font-size: 0.21rem;
        line-height: 0.3rem;
    }
     .coupon-info .coupon-time .go-tag{
      border-radius: 0.14rem;
      line-height: 0.25rem;
      font-size: 0.18rem;
      padding: 0 0.07rem;
      position: absolute;
      right: 0;
      top: 0;
    }
     .coupon-info .coupon-details{
      font-size: 0.21rem;
      line-height: 0.3rem;
      margin-top: 0.07rem;
      border-top: 0.01rem dashed #EEEEEE;
      padding-top: 0.1rem;
    }
    .coupon-info .coupon-details img {
        width: 0.22rem;
        margin-top: 0.02rem;
    }
  }
    
    
</style>